





































import {Component, Prop, Vue} from 'vue-property-decorator';
import {Brand} from '@/modules/neovehicle/models';
import {FamilyGroupCreateModel} from '@/modules/neovehicle/models/family';

@Component
export default class extends Vue {
  @Prop({required: true})
  public brands: Brand[];

  @Prop({required: true})
  public isOpen: boolean;

  public familyGroup: FamilyGroupCreateModel = {
    idBrand: 0,
    familyGroupName: '',
  };

  public isOpenInternal: boolean = false;

  public get isValid() {
    return this.familyGroup.idBrand !== 0
      && this.familyGroup.familyGroupName.length !== 0;
  }

  public mounted() {
    this.isOpenInternal = this.isOpen;
  }

  public handleCancel() {
    this.$emit('cancel');
  }

  public handleSave() {
    this.$emit('save', this.familyGroup);
  }
}
